import React from "react";
import ReactLoading from "react-loading";

const Loader = ({type}) => {
    return (
        <ReactLoading type={type} color={"#005686"} height={30} width={30}/>
    );
};

export default Loader;